import React from 'react';
import Style from './Home.module.scss';
import me from '../../img/self.png';
import classNames from 'classnames';
import EmojiBullet from "./EmojiBullet";
import SocialIcon from "./SocialIcon";
import {Box, Button} from "@mui/material";
import {useInfo} from "../../info/Info";
import {LanguageContext} from "../../context/LanguageContext";

export default function Home({innerRef}) {
   const info = useInfo();
   const { language } = React.useContext(LanguageContext);

   return (
      <Box ref={innerRef} component={'main'} display={'flex'} flexDirection={{xs: 'column', md: 'row'}} alignItems={'center'}
           justifyContent={'center'} minHeight={'calc(100vh - 175px)'} id={'home'}>
         <Box className={classNames(Style.avatar, Style.shadowed)} alt={'image of developer'} style={{background: info.gradient}} component={'img'} src={me} width={{xs: '35vh', md: '40vh'}}
              height={{xs: '35vh', md: '40vh'}}
              borderRadius={'50%'} p={'0.75rem'} mb={{xs: '1rem', sm: 0}} mr={{xs: 0, md: '2rem'}}/>
         <Box>
            <h1>{language === 'pt' ? 'Olá, sou o ' : "Hi, I'm "}<span style={{background: info.gradient, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'}}>{info.firstName}</span><span className={Style.hand}>🤚</span>
            </h1>
            <h2>{language === 'pt' ? 'Eu ' : 'I '}{info.position}.</h2>
            <Box component={'ul'} p={'0.8rem'}>
               {info.miniBio.map((bio, index) => (
                  <EmojiBullet key={index} emoji={bio.emoji} text={bio.text}/>
               ))}
            </Box>
            <Box display={'flex'} gap={'1.5rem'} justifyContent={'center'} fontSize={{xs: '2rem', md: '2.5rem'}}>
               {info.socials.map((social, index) => (
                  <SocialIcon key={index} link={social.link} icon={social.icon} label={social.label} />
               ))}
            </Box>

            {info.resume && (
               <Box display="flex" justifyContent="center" mt={4}>
                  <Button variant="contained" href="/curriculum"
                      sx={{ borderRadius: '50px', px: 4, py: 1.2, textTransform: 'none', fontWeight: 600, fontSize: '1rem', backgroundColor: '#111', color: '#fff', '&:hover': { backgroundColor: '#333', transform: 'translateY(-2px)' }, transition: 'all 0.2s ease', boxShadow: '0 8px 20px rgba(0,0,0,0.15)' }}>
                      <i className="fa-regular fa-file-lines" style={{ marginRight: '10px' }}></i> {language === 'pt' ? 'Ver CV' : 'View CV'}
                  </Button>
               </Box>
            )}
         </Box>
      </Box>
   )
}